<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <p class="Form__tx Form__tx--mb_sm">
            変更後のパスワードをご入力ください。
          </p>
          <div class="Form__area">
            <div :class="`Form__input_box Form__input_box--mb_md Form__input_box--md ${$v.userInfo.password.$error ? '_error' : ''}`">
              <div class="Form__input_heda Form__input_head_required Form__input_head_required_tx_box">
                新しいパスワード<span class="Form__input_head_required_tx" />
              </div>
              <input
                v-model.trim="$v.userInfo.password.$model"
                class="Form__input"
                type="password"
                pattern="^(?=.*?[a-zA-Z])(?=.*?\d)[a-zA-Z\d]{10,}$"
                placeholder="10文字以上で設定してください"
                required=""
              >
              <div class="Form__error_box">
                <div class="Form__error_tx">
                  <label v-if="!$v.userInfo.password.required">パスワードを入力してください</label>
                </div>
                <div class="Form__error_tx">
                  <label v-if="!$v.userInfo.password.minLength">10文字以上で設定してください</label>
                </div>
                <div class="Form__error_tx">
                  <label v-if="!$v.userInfo.password.regexPassword">数字、英字を含めて設定してください</label>
                </div>
              </div>
            </div>
            <div :class="`Form__input_box Form__input_box--md ${$v.userInfo.password_confirmation.$error ? '_error' : ''}`">
              <div class="Form__input_heda Form__input_head_required">
                新しいパスワード（確認用）
              </div>
              <input
                v-model.trim="$v.userInfo.password_confirmation.$model"
                class="Form__input"
                type="password"
                placeholder="*********"
                required
              >
              <div class="Form__error_box">
                <div class="Form__error_tx">
                  <label v-if="!$v.userInfo.password_confirmation.required">パスワードの確認が必要です</label>
                </div>
                <div class="Form__error_tx">
                  <label v-if="!$v.userInfo.password_confirmation.sameAsPassword">パスワードと確認用パスワードが異なっています。</label>
                </div>
              </div>
            </div>
            <button :disabled="$v.userInfo.$invalid || isLoading" class="Btn__blue Form__btn Form__btn--sm_sp Form__btn--mt_md Form__btn--mt_lg Form__btn--mt_sp_lg" @click="updateUserInfo()">
              変更する
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import authService from '@/services/authService'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { redirect } from '@/helpers'
import { regexPassword } from '@/helpers/validations'

const validations = {
  userInfo: {
    password: {
      required,
      minLength: minLength(10),
      regexPassword
    },
    password_confirmation: {
      required,
      sameAsPassword: sameAs('password')
    }
  }
}
export default {
  name: 'ChangeName',
  mixins: [validationMixin],
  data() {
    return {
      userInfo: {
        password: '',
        password_confirmation: ''
      },
      isLoading: false,
      showError: false
    }
  },
  mounted() {
  },
  methods: {
    async updateUserInfo() {
      this.$v.userInfo.$touch()
      if (this.$v.userInfo.$invalid) {
        return
      }
      const redirectPath = '/change/password/thanks'
      this.$store.dispatch('loading/updateLoading', true)
      await authService.updateUserInfo(this.userInfo)
      this.$store.dispatch('loading/updateLoading', false)
      redirect(redirectPath)
    }
  },
  validations: validations
}
</script>
